import { createSlice } from '@reduxjs/toolkit';
import { find } from 'lodash';
import { createSelector } from 'reselect';

const initialState = {
  invoices: [],
  currentPage: 1,
  totalPages: 1,
  totalCount: 0,
  loading: false,
  isInvoiceCreated: false,
  isInvoiceEdited: false,
  selectedInvoice: {},
  error: null,
};

const invoiceSlice = createSlice({
  name: 'invoices',
  initialState,
  reducers: {
    fetchInvoicesRequest(state) {
      state.loading = true;
      state.error = null;
    },
    fetchInvoicesSuccess(state, action) {
      state.loading = false;
      state.invoices = action.payload.invoices;
      state.currentPage = action.payload.currentPage;
      state.totalPages = action.payload.totalPages;
      state.totalCount = action.payload.totalCount;
    },
    fetchInvoicesFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    fetchInvoiceById(state) {
      state.loading = true;
      state.error = null;
    },
    fetchInvoiceByIdSuccess(state, action) {
      const invoice = action.payload;
      let found = find(state.invoices, { _id: invoice._id });
      if (!found) {
        state.invoices.push(invoice);
      }

      state.loading = false;
      state.selectedInvoice = action.payload;
    },
    fetchInvoiceByIdFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    createInvoiceRequest(state) {
      state.loading = true;
      state.error = null;
      state.isInvoiceCreated = false;
    },
    editInvoiceRequest(state) {
      state.loading = true;
      state.error = null;
      state.isInvoiceEdited = false;
    },
    createInvoiceSuccess(state) {
      state.loading = false;
      state.error = null;
      state.isInvoiceCreated = true;
    },
    editInvoiceFailure(state, action) {
      state.loading = false;
      state.isInvoiceEdited = false;
      state.error = action.payload;
    },
    editInvoiceSuccess(state) {
      state.loading = false;
      state.error = null;
      state.isInvoiceEdited = true;
    },
    createInvoiceFailure(state, action) {
      state.loading = false;
      state.isInvoiceCreated = false;
      state.error = action.payload;
    },
    cancelInvoiceCreate(state) {
      state.loading = false;
      state.error = null;
      state.isInvoiceCreated = false;
      state.isInvoiceEdited = false;
    },
    markInvoiceCreated(state, action) {
      state.isInvoiceCreated = action.payload;
    },
    markInvoiceEdited(state, action) {
      state.isInvoiceEdited = action.payload;
    },
  },
});

export const {
  fetchInvoicesRequest,
  fetchInvoicesSuccess,
  fetchInvoicesFailure,
  fetchInvoiceById,
  fetchInvoiceByIdSuccess,
  fetchInvoiceByIdFailure,
  createInvoiceRequest,
  createInvoiceSuccess,
  createInvoiceFailure,
  editInvoiceRequest,
  editInvoiceFailure,
  editInvoiceSuccess,
  markInvoiceCreated,
  markInvoiceEdited,
  cancelInvoiceCreate,
} = invoiceSlice.actions;

const invoiceState = (state) => state.invoices;

export const selectInvoiceById = (id) =>
  createSelector([invoiceState], (invoiceState) => invoiceState.invoices.find((invoice) => invoice._id === id) || {});

export default invoiceSlice.reducer;
